import { EmailCaptureForm } from '@/shared/components/forms';
import type { EmailFormData } from '@/shared/components/forms';

interface Hero24Props {
  title?: string;
  description?: string;
  backgroundImage?: string;
  badgeLabel?: string;
}

export const Hero24 = ({
  title = 'Achieve more with less through automation',
  description = 'Mauris donec ociis diam magnis sapien sagittis sapien tempor volute gravida aliquet tortor undo aliquet an egestas in magna egestas sapien quaerat',
  backgroundImage = '/images/hero-24.jpg',
  badgeLabel = '✨ How BrokerMax Works'
}: Hero24Props) => {
  const handleFormSubmit = async (_data: EmailFormData) => {
    // Handle form submission
    console.log('Form submitted:', _data);
  };

  return (
    <section
      id="hero-24"
      className="bg--scroll hero-section relative z-[3] bg-[url(./images/hero-24.jpg)] pt-[200px] xl:!pb-[150px] lg:max-xl:pt-[40px] lg:max-xl:!pb-[110px] py--100 md:max-lg:py-[100px] sm:max-md:!py-[80px] xsm:max-sm:!py-[80px] w-full bg-no-repeat bg-[center_center] bg-cover bg-fixed sm:max-md:w-auto sm:max-md:bg-scroll xsm:max-sm:w-auto xsm:max-sm:bg-scroll md:max-lg:!mt-[80px]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="container !text-center">
        {/* HERO TEXT */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-center">
          <div className="md:w-11/12 lg:max-xl:w-10/12 xl:w-10/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="hero-24-txt color--white wow fadeInUp">
              <div
                className="case-badge"
                style={{
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  width: 'fit-content',
                  background: 'transparent',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: 'white',
                  borderRadius: '999px',
                  padding: '8px 16px',
                  margin: '0 auto',
                  marginBottom: '32px'
                }}
              >
                <span
                  style={{
                    color: 'white'
                  }}
                >
                  {badgeLabel}
                </span>
              </div>
              {/* Title */}
              <h2 className="s-60 w--700 xl:!text-[3.75rem] lg:max-xl:!text-[3.5rem] xsm:max-sm:!text-[2.0625rem] md:max-lg:!text-[3.23529rem] sm:max-md:!text-[2.625rem] !font-bold xl:!mb-[28px] lg:max-xl:!mb-[24px] md:max-lg:!mb-[18px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[18px] leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35]">
                {title}
              </h2>
              {/* Text */}
              <p className="p-xl">{description}</p>
              {/* HERO QUICK FORM */}
              <EmailCaptureForm
                onSubmit={handleFormSubmit}
                submitText="Get updates"
                submittingText="Submitting..."
                placeholder="Your email address"
                variant="hero-24"
              />
            </div>
          </div>
        </div>
        {/* END HERO TEXT */}
      </div>
      {/* End container */}
    </section>
  );
};
